import React from 'react';

function ProfilePage() {
  return <div></div>;
}

export default ProfilePage;
